export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Index.vue?vue&type=template&id=efebff34&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/pages/Index.vue?vue&type=template&id=efebff34&
// module id = 718
// module chunks = 0